import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { relationshipDisplayedTitle } from '~/business-logic/relationshipLogic';
import { fullName } from '~/infra/utils';
import { reindexDisplayOrders, sortedPages } from '~/models/custom-page';
import { applyBilledUponAmendment } from '~/models/service-billing/amendment';
import { isCreditCard } from '../payment-method';
import * as serviceModel from '../service';
import * as timeModel from '../time';
import { acceptAmendmentDraftChange, modificationRecordOf } from './amendment';
import { RelationshipStatus } from './model';
export function id(relationship) {
    return relationship.id;
}
export function isSample(relationship) {
    return relationship.isSample;
}
export function isVendorCoveringCCFee(relationship) {
    return relationship.feeControls.coverCreditCardFees;
}
export function isCreditCardPaymentMethod(relationship) {
    return relationship.paymentMethod != null && isCreditCard(relationship.paymentMethod);
}
export function updatedIsVendorCoveringCCFee(relationship) {
    return relationship.pendingAmendments.find((a)=>a.isCoverCreditCardFees());
}
export function updatedIsVendorCoveringCCFeeValue(relationship) {
    var _updatedIsVendorCoveringCCFee;
    return (_updatedIsVendorCoveringCCFee = updatedIsVendorCoveringCCFee(relationship)) === null || _updatedIsVendorCoveringCCFee === void 0 ? void 0 : _updatedIsVendorCoveringCCFee.value();
}
export function updatedIsVendorCoveringCCFeeAutoApprovalDate(relationship) {
    const updated = updatedIsVendorCoveringCCFee(relationship);
    return updated ? updated.approvalMethod().autoApprovalDate() : null;
}
export function actualIsVendorCoveringCCFee(relationship) {
    var _updatedIsVendorCoveringCCFeeValue;
    return (_updatedIsVendorCoveringCCFeeValue = updatedIsVendorCoveringCCFeeValue(relationship)) !== null && _updatedIsVendorCoveringCCFeeValue !== void 0 ? _updatedIsVendorCoveringCCFeeValue : isVendorCoveringCCFee(relationship);
}
export function vendor(relationship) {
    return relationship.vendor.id;
}
export function customer(relationship) {
    return relationship.customer.id;
}
export function getService(relationship, serviceId) {
    return relationship.services.find((service)=>service.id === serviceId);
}
export function effectiveDate(relationship) {
    const effectiveDate = relationship.effectiveDate;
    return effectiveDate != null ? new Date("".concat(effectiveDate.year, "-").concat(effectiveDate.month, "-").concat(effectiveDate.day)) : null;
}
export function updatedNetTerms(relationship) {
    return relationship.pendingAmendments.find((a)=>a.isNetTerms());
}
export function updatedNetTermsAutoApprovalDate(relationship) {
    const updated = updatedNetTerms(relationship);
    return updated ? updated.approvalMethod().autoApprovalDate() : null;
}
export function updatedNetTermsValue(relationship) {
    var _updatedNetTerms;
    return (_updatedNetTerms = updatedNetTerms(relationship)) === null || _updatedNetTerms === void 0 ? void 0 : _updatedNetTerms.value();
}
export function inProgressNetTerms(relationship) {
    return relationship.inProgressAmendments.find((a)=>a.isNetTerms());
}
export function inProgressNetTermsValue(relationship) {
    var _inProgressNetTerms;
    return (_inProgressNetTerms = inProgressNetTerms(relationship)) === null || _inProgressNetTerms === void 0 ? void 0 : _inProgressNetTerms.value();
}
export function actualNetTerms(relationship) {
    var _updatedNetTermsValue;
    return (_updatedNetTermsValue = updatedNetTermsValue(relationship)) !== null && _updatedNetTermsValue !== void 0 ? _updatedNetTermsValue : relationship.netTerms;
}
export function updatedAmendmentsApprovalMethod(relationship) {
    return relationship.pendingAmendments.find((a)=>a.isAmendmentsApprovalMethod());
}
export function updatedInvoicesApprovalMethod(relationship) {
    return relationship.pendingAmendments.find((a)=>a.isInvoicesApprovalMethod());
}
export function updatedAmendmentsApprovalMethodValue(relationship) {
    var _updatedAmendmentsApprovalMethod;
    return (_updatedAmendmentsApprovalMethod = updatedAmendmentsApprovalMethod(relationship)) === null || _updatedAmendmentsApprovalMethod === void 0 ? void 0 : _updatedAmendmentsApprovalMethod.value();
}
export function updatedInvoicesApprovalMethodValue(relationship) {
    var _updatedInvoicesApprovalMethod;
    return (_updatedInvoicesApprovalMethod = updatedInvoicesApprovalMethod(relationship)) === null || _updatedInvoicesApprovalMethod === void 0 ? void 0 : _updatedInvoicesApprovalMethod.value();
}
export function updatedAmendmentsApprovalMethodAutoApprovalDate(relationship) {
    const updated = updatedAmendmentsApprovalMethod(relationship);
    return updated ? updated.approvalMethod().autoApprovalDate() : null;
}
export function updatedInvoicesApprovalMethodAutoApprovalDate(relationship) {
    const updated = updatedInvoicesApprovalMethod(relationship);
    return updated ? updated.approvalMethod().autoApprovalDate() : null;
}
export function actualAmendmentsApprovalMethod(relationship) {
    const updatedAmendmentsApprovalMethod = updatedAmendmentsApprovalMethodValue(relationship);
    return updatedAmendmentsApprovalMethod != null ? updatedAmendmentsApprovalMethod : relationship.amendmentsApprovalMethod;
}
export function actualInvoicesApprovalMethod(relationship) {
    const updatedInvoicesApprovalMethod = updatedInvoicesApprovalMethodValue(relationship);
    return updatedInvoicesApprovalMethod != null ? updatedInvoicesApprovalMethod : relationship.invoicesApprovalMethod;
}
export function updatedAllowManualPayments(relationship) {
    return relationship.pendingAmendments.find((a)=>a.isAllowManualPayments());
}
export function updatedAllowManualPaymentsValue(relationship) {
    var _updatedAllowManualPayments;
    return (_updatedAllowManualPayments = updatedAllowManualPayments(relationship)) === null || _updatedAllowManualPayments === void 0 ? void 0 : _updatedAllowManualPayments.value();
}
export function updatedAllowManualPaymentsAutoApprovalDate(relationship) {
    const updated = updatedAllowManualPayments(relationship);
    return updated ? updated.approvalMethod().autoApprovalDate() : null;
}
export function actualAllowManualPayments(relationship) {
    const updated = updatedAllowManualPayments(relationship);
    return updated ? updated.value() : relationship.allowManualPayments;
}
export function hasAutoAmendments(relationship) {
    return relationship.services.some(serviceModel.hasAutoAmendments) || relationship.pendingAmendments.some((a)=>a.approvalMethod().isAutoApproval());
}
export function hasAmendments(relationship) {
    return numAmendments(relationship) !== 0;
}
export function numAmendments(relationship) {
    if (!isApproved(relationship)) return 0;
    return relationship.pendingAmendments.length + relationship.services.filter(serviceModel.requiresClientApproval).length;
}
export function numPendingInvoices(relationship) {
    return relationship.invoiceStatus.numRequiresPaymentApproval + relationship.invoiceStatus.numPaymentActionRequired;
}
export function numInvoicesRequiringApproval(relationship) {
    return relationship.invoiceStatus.numRequiresPaymentApproval;
}
export function numPendingCharges(relationship) {
    return relationship.adHocChargeStatus.numAwaitingApproval;
}
export function isCanceled(param) {
    let { status } = param;
    return status === RelationshipStatus.Canceled;
}
export function sellerFullName(relationship) {
    const { firstName, lastName } = relationship.seller;
    return fullName(firstName, lastName);
}
export function buyerFullName(relationship) {
    const { firstName, lastName } = relationship.buyer;
    return fullName(firstName, lastName);
}
export function reviewerFullName(reviewer) {
    return fullName(reviewer.firstName, reviewer.lastName);
}
export function sellerEmail(relationship) {
    return relationship.seller.email;
}
export function sellerID(relationship) {
    return relationship.seller.id;
}
export function buyerEmail(relationship) {
    return relationship.buyer.email;
}
export function buyerFirstName(relationship) {
    return relationship.buyer.firstName;
}
export function isBuyer(relationship, userId) {
    return relationship.buyer.id === userId;
}
export function isApproved(param) {
    let { status } = param;
    return status === RelationshipStatus.Approved;
}
const ABSOLUTE_HTTPS_PREFIX = /^https:\/\//i;
function isOpenableIntakeLink(param) {
    let { url } = param;
    if (!ABSOLUTE_HTTPS_PREFIX.test(url)) {
        return false;
    }
    try {
        const { username, password } = new URL(url);
        return username === '' && password === '';
    } catch (unused) {
        return false;
    }
}
export function openableIntakeLinks(relationship) {
    var _relationship_intakeLinks;
    return ((_relationship_intakeLinks = relationship.intakeLinks) !== null && _relationship_intakeLinks !== void 0 ? _relationship_intakeLinks : []).filter(isOpenableIntakeLink);
}
export function hasIntakeLinks(relationship) {
    return openableIntakeLinks(relationship).length > 0;
}
export function amendmentDraftChanges(relationship) {
    var _ref;
    var _relationship_amendment;
    return (_ref = (_relationship_amendment = relationship.amendment) === null || _relationship_amendment === void 0 ? void 0 : _relationship_amendment.draft.changes) !== null && _ref !== void 0 ? _ref : [];
}
export function hasAmendmentDraftChanges(relationship) {
    return amendmentDraftChanges(relationship).length > 0;
}
export function lastModificationRecord(relationship) {
    return modificationRecordOf(relationship.lastModification);
}
export function amendmentDraftVersion(relationship) {
    var _ref;
    var _relationship_amendment;
    return (_ref = (_relationship_amendment = relationship.amendment) === null || _relationship_amendment === void 0 ? void 0 : _relationship_amendment.draft.version) !== null && _ref !== void 0 ? _ref : '';
}
function amendmentDraftServiceNotes(relationship) {
    var _ref;
    var _relationship_amendment;
    return (_ref = (_relationship_amendment = relationship.amendment) === null || _relationship_amendment === void 0 ? void 0 : _relationship_amendment.draft.serviceNotes) !== null && _ref !== void 0 ? _ref : [];
}
function applyServiceFieldChange(service, partial) {
    var _serviceModel_changes;
    if (serviceModel.isAwaitingApproval(service.status)) {
        return serviceModel.applyFieldChanges(service, partial);
    }
    const existing = (_serviceModel_changes = serviceModel.changes(service)) !== null && _serviceModel_changes !== void 0 ? _serviceModel_changes : serviceModel.makeChanges({});
    return serviceModel.setChanges(service, serviceModel.makeChanges(_object_spread({}, existing, partial)));
}
export function amendmentDraftServices(relationship) {
    const servicesById = new Map(relationship.services.map((service)=>[
            service.id,
            service
        ]));
    const updateService = (serviceId, updater)=>{
        const service = servicesById.get(serviceId);
        if (service && !serviceModel.hasEnded(service.status)) servicesById.set(serviceId, updater(service));
    };
    const applyField = (serviceId, partial)=>updateService(serviceId, (service)=>applyServiceFieldChange(service, partial));
    for (const change of amendmentDraftChanges(relationship)){
        acceptAmendmentDraftChange(change, {
            visitServiceAddition: (value)=>{
                const existing = servicesById.get(value.serviceId);
                if (existing == null || !serviceModel.hasEnded(existing.status)) {
                    servicesById.set(value.serviceId, value.service);
                }
            },
            visitServiceNameUpdate: (value)=>applyField(value.serviceId, {
                    name: value.name
                }),
            visitServiceDescriptionUpdate: (value)=>applyField(value.serviceId, {
                    description: value.description
                }),
            visitServiceTermsUpdate: (value)=>applyField(value.serviceId, {
                    terms: value.terms
                }),
            visitServiceTermsRemoval: (value)=>applyField(value.serviceId, {
                    terms: ''
                }),
            visitServiceCostUpdate: (value)=>applyField(value.serviceId, {
                    cost: value.cost
                }),
            visitServiceBillingTriggerUpdate: (value)=>updateService(value.serviceId, (service)=>applyServiceFieldChange(service, {
                        billing: applyBilledUponAmendment(service.billing, value.billedUpon)
                    })),
            visitServiceBundleUpdate: (value)=>applyField(value.serviceId, {
                    bundle: value.bundle
                }),
            visitServiceTermination: (value)=>updateService(value.serviceId, (service)=>serviceModel.setTerminated(service)),
            visitServiceCancellation: (value)=>updateService(value.serviceId, (service)=>serviceModel.setCanceled(service)),
            visitServiceTaxabilityUpdate: (value)=>updateService(value.serviceId, (service)=>serviceModel.setTaxable(service, value.taxable)),
            visitServiceIntegratedClassUpdate: (value)=>updateService(value.serviceId, (service)=>{
                    var _value_integratedClass;
                    return serviceModel.setIntegratedClass(service, ((_value_integratedClass = value.integratedClass) === null || _value_integratedClass === void 0 ? void 0 : _value_integratedClass.id) ? serviceModel.makeIntegratedClassSet(value.integratedClass.id) : serviceModel.makeIntegratedClassUnset());
                })
        });
    }
    for (const serviceNote of amendmentDraftServiceNotes(relationship)){
        updateService(serviceNote.serviceId, (service)=>serviceModel.setNote(service, serviceNote.note));
    }
    return [
        ...servicesById.values()
    ];
}
export function amendmentDraftServiceCostUpdates(relationship) {
    const savedCostChanges = new Map();
    for (const change of amendmentDraftChanges(relationship)){
        acceptAmendmentDraftChange(change, {
            visitServiceCostUpdate: (value)=>savedCostChanges.set(value.serviceId, {
                    cost: value.cost,
                    conflicts: value.conflicts
                })
        });
    }
    return savedCostChanges;
}
export function amendmentDraftNetTerms(relationship) {
    let netTerms = actualNetTerms(relationship);
    for (const change of amendmentDraftChanges(relationship)){
        acceptAmendmentDraftChange(change, {
            visitNetTermsUpdate: (value)=>{
                netTerms = value.netTerms.type === 'immediate' ? 0 : value.netTerms.days;
            }
        });
    }
    return netTerms;
}
export function amendmentDraftTaxSettings(relationship) {
    var _relationship_tax;
    let taxSettings = (_relationship_tax = relationship.tax) !== null && _relationship_tax !== void 0 ? _relationship_tax : {
        type: 'none'
    };
    for (const change of amendmentDraftChanges(relationship)){
        acceptAmendmentDraftChange(change, {
            visitTaxSettingsUpdate: (value)=>{
                taxSettings = value.taxSettings;
            }
        });
    }
    return taxSettings;
}
export function amendmentDraftAllowManualPayments(relationship) {
    let allowManualPayments = actualAllowManualPayments(relationship);
    for (const change of amendmentDraftChanges(relationship)){
        acceptAmendmentDraftChange(change, {
            visitPaymentApprovalRequirementUpdate: (value)=>{
                allowManualPayments = value.allowManualPayments;
            }
        });
    }
    return allowManualPayments;
}
export function amendmentDraftCoverCreditCardFees(relationship) {
    let coverCreditCardFees = actualIsVendorCoveringCCFee(relationship);
    for (const change of amendmentDraftChanges(relationship)){
        acceptAmendmentDraftChange(change, {
            visitCreditCardFeeCoverageUpdate: (value)=>{
                coverCreditCardFees = value.coverCreditCardFees;
            }
        });
    }
    return coverCreditCardFees;
}
export function amendmentDraftAmendmentsApprovalMethod(relationship) {
    let amendmentsApprovalMethod = actualAmendmentsApprovalMethod(relationship);
    for (const change of amendmentDraftChanges(relationship)){
        acceptAmendmentDraftChange(change, {
            visitAmendmentsApprovalMethodUpdate: (value)=>{
                amendmentsApprovalMethod = value.amendmentsApprovalMethod;
            }
        });
    }
    return amendmentsApprovalMethod;
}
export function amendmentDraftInvoicesApprovalMethod(relationship) {
    let invoicesApprovalMethod = actualInvoicesApprovalMethod(relationship);
    for (const change of amendmentDraftChanges(relationship)){
        acceptAmendmentDraftChange(change, {
            visitInvoicesApprovalMethodUpdate: (value)=>{
                invoicesApprovalMethod = value.invoicesApprovalMethod;
            }
        });
    }
    return invoicesApprovalMethod;
}
export function amendmentDraftSelectedLegalTerms(relationship) {
    let selectedLegalTerms = relationship.legalTermsDocuments;
    for (const change of amendmentDraftChanges(relationship)){
        acceptAmendmentDraftChange(change, {
            visitLegalTermsDocumentsUpdate: (value)=>{
                selectedLegalTerms = value.legalTermsDocuments;
            }
        });
    }
    return selectedLegalTerms;
}
export function amendmentDraftCustomPages(relationship) {
    var _relationship_customPages;
    const pagesById = new Map(((_relationship_customPages = relationship.customPages) !== null && _relationship_customPages !== void 0 ? _relationship_customPages : []).map((page)=>[
            page.id,
            page
        ]));
    for (const change of amendmentDraftChanges(relationship)){
        acceptAmendmentDraftChange(change, {
            visitCustomPageAddition: (value)=>pagesById.set(value.page.id, value.page),
            visitCustomPageUpdate: (value)=>pagesById.set(value.page.id, value.page)
        });
    }
    return reindexDisplayOrders(sortedPages([
        ...pagesById.values()
    ]));
}
export function isTerminated(param) {
    let { status } = param;
    return status === RelationshipStatus.Terminated;
}
export function isPending(param) {
    let { status } = param;
    return status === RelationshipStatus.Pending;
}
export function isExpired(param) {
    let { status } = param;
    return status === RelationshipStatus.Expired;
}
export function isAdHoc(param) {
    let { status } = param;
    return !status || status === RelationshipStatus.AdHoc;
}
export function isEditable(relationship) {
    return !isTerminated(relationship) && (isApproved(relationship) || isAdHoc(relationship));
}
export function actualServices(relationship, selectedBundleID) {
    var _relationship_serviceBundles_bundles_find;
    const services = relationship.serviceBundles ? ((_relationship_serviceBundles_bundles_find = relationship.serviceBundles.bundles.find((b)=>b.id === selectedBundleID)) === null || _relationship_serviceBundles_bundles_find === void 0 ? void 0 : _relationship_serviceBundles_bundles_find.services) || [] : relationship.services;
    return services.map(serviceModel.applyChanges);
}
export const opposingPartyName = (rel, isVendor)=>isVendor ? customerName(rel) : vendorName(rel);
export function paymentMethod(relationship) {
    return relationship.paymentMethod;
}
export function paymentMethodType(relationship) {
    return relationship.paymentMethod ? relationship.paymentMethod.type : 'unknown';
}
export function customerName(relationship) {
    return relationship.suggestedCustomerName || relationship.customer.name;
}
export function selectedFundingSourceId(relationship) {
    var _relationship_customerSelections;
    return ((_relationship_customerSelections = relationship.customerSelections) === null || _relationship_customerSelections === void 0 ? void 0 : _relationship_customerSelections.fundingSourceId) || null;
}
export function vendorName(relationship) {
    return relationship.vendor.name;
}
export function vendorID(relationship) {
    return relationship.vendor.id;
}
export function vendorLogoUrl(relationship) {
    return relationship.vendor.logoUrl;
}
export const onAcceptanceTextsPath = 'service.model.validation';
export const paymentTermsTextsPath = 'clientFlow.additionalTerms';
export function formatEffectiveDate(relationship, texts) {
    const { effectiveDate } = relationship;
    return effectiveDate ? timeModel.formatDateLong(effectiveDate) : texts.onAcceptance();
}
export function isSignatory(relationship, userId) {
    var _relationship_signatories;
    return !!((_relationship_signatories = relationship.signatories) === null || _relationship_signatories === void 0 ? void 0 : _relationship_signatories.some((s)=>s.id === userId));
}
export function isAwaitingApproval(relationship) {
    return isPending(relationship) && !relationship.withdrawnForEditing;
}
export function signingOrdinalOf(relationship, userId) {
    var _ref;
    var _relationship_signatories;
    if (relationship.buyer.id === userId) return 1;
    const signatoryIndex = (_ref = (_relationship_signatories = relationship.signatories) === null || _relationship_signatories === void 0 ? void 0 : _relationship_signatories.findIndex((s)=>s.id === userId)) !== null && _ref !== void 0 ? _ref : -1;
    return signatoryIndex === -1 ? null : signatoryIndex + 2;
}
export function personOfOrdinal(relationship, ordinal, actorUserId) {
    var _reviewerFullName;
    const person = ordinal === 1 ? relationship.buyer : relationship.signingSignatories[ordinal - 2];
    const actedAsSomeoneElse = actorUserId != null && (person === null || person === void 0 ? void 0 : person.id) !== actorUserId;
    return person == null || actedAsSomeoneElse ? {
        ordinalLabel: ordinal
    } : {
        name: (_reviewerFullName = reviewerFullName(person)) !== null && _reviewerFullName !== void 0 ? _reviewerFullName : person.email
    };
}
export function hasAdditionalRecipients(relationship) {
    return !!(relationship.reviewers.length > 0 || relationship.signatories && relationship.signatories.length > 0);
}
export function hasSignatorySigned(relationship, signatoryId) {
    var _relationship_signatories;
    const signatory = (_relationship_signatories = relationship.signatories) === null || _relationship_signatories === void 0 ? void 0 : _relationship_signatories.find((s)=>s.id === signatoryId);
    return !!(signatory === null || signatory === void 0 ? void 0 : signatory.approvalRecord);
}
export function selectedBundleId(relationship) {
    var _relationship_customerSelections;
    return ((_relationship_customerSelections = relationship.customerSelections) === null || _relationship_customerSelections === void 0 ? void 0 : _relationship_customerSelections.bundleId) || null;
}
export function selectedOptionalServices(relationship) {
    var _relationship_customerSelections;
    return ((_relationship_customerSelections = relationship.customerSelections) === null || _relationship_customerSelections === void 0 ? void 0 : _relationship_customerSelections.optionalServices) || [];
}
export function includedByDefaultOptionalServices(relationship, selectedBundleID) {
    return actualServices(relationship, selectedBundleID).filter((s)=>serviceModel.isOptional(s.participation) && s.participation.optional.includedByDefault).map((s)=>s.id);
}
export function isReviewer(relationship, userId) {
    return relationship.reviewers.some((r)=>r.id === userId);
}
export function hasSignatories(relationship) {
    return relationship.signatories ? relationship.signatories.length > 0 : false;
}
export function status(relationship) {
    return relationship.status;
}
export function paymentTermsText(relationship, texts) {
    const netTerms = actualNetTerms(relationship);
    const manualPayments = actualAllowManualPayments(relationship) ? 'requiresApproval' : 'automatic';
    if (netTerms > 0) {
        return texts.paymentDueAfterDays({
            count: netTerms,
            manualPayments
        });
    }
    return texts.paymentDueOnReceipt({
        manualPayments
    });
}
export function displayedTitle(relationship, isVendor) {
    return relationshipDisplayedTitle(relationship.title, opposingPartyName(relationship, isVendor));
}
export function practiceManagementSyncFailures(relationship) {
    return relationship.practiceManagementSyncFailures || [];
}
